import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { CareersComponent } from "./careers/jobs.component";
import { MarketingModule } from "@rubbl-marketing";
import { LayoutModule } from "@rubbl-layout";

const routes: Routes = [
  {
    path: "rent-machines",
    loadChildren: () => import("./rent-a-machine/rent-a-machine.module").then(m => m.RentAMachineModule),
  },
  {
    path: "how-it-works",
    loadChildren: () => import("./how-it-works/how-it-works.module").then(m => m.HowItWorksModule),
  },
  {
    path: "list-your-machines",
    loadChildren: () => import("./list-your-machines/list-your-machines.module").then(m => m.ListYourMachinesModule),
  },
  {
    path: "careers",
    component: CareersComponent,
  },
];
@NgModule({
  declarations: [CareersComponent],
  imports: [CommonModule, RouterModule.forChild(routes), MarketingModule, LayoutModule],
})
export class LandingPageModule {}
